import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=2a13552f"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=2a13552f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports